module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isAppLoaded) ? _c('preloader') : _vm._e()], 1), _vm._v(" "), (_vm.isAppLoaded) ? _c('div', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isModalOpen) ? _c('modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isModalVideoOpen) ? _c('video-modal') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isMenuOpen) ? _c('main-menu') : _vm._e()], 1), _vm._v(" "), _c('video-static-modal', {
    attrs: {
      "videoType": _vm.modalStaticVideoType
    }
  }), _vm._v(" "), _c('main-header'), _vm._v(" "), _c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('canvas-animation'), _vm._v(" "), _c('ScrollTop')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 309
// module chunks = 0